<template>
  <el-row>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </el-row>
</template>

<script>
export default {
  name: 'ResourceListPageFooter',
  inject: {
    pageOption: {
      from: 'pageOption',
      default: () => ({ total: 0, currentPage: 1, searchCurrentPage: 1, pageSize: 30 })
    }
  },
  props: {
  },
  components: {
  },
  data () {
    return {
      // pageOption: {
      //   total: 0,
      //   currentPage: 1, // 当前页数
      //   searchCurrentPage: 1,
      //   pageSize: 30, // 每页显示条数
      // }
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      console.log(val)
      // this.getPageData();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      // this.getPageData();
    }
  },
  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
.el-pagination {
  padding-top: .2rem;
}
</style>



// WEBPACK FOOTER //
// src/common/ResourceListPageFooter.vue